import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import styles from "./CtaSection.module.css";
import CtaButton from "../components/CtaButton";
import ScrollReveal from "../components/ScrollReveal";
import { FaCheck } from "react-icons/fa";

const benefits = [
  { id: "cta.benefit1", def: "Cadastro gratuito, sem cartão de crédito" },
  { id: "cta.benefit2", def: "Primeiro projeto compartilhado em minutos" },
  { id: "cta.benefit3", def: "Suporte via WhatsApp incluído" }
];

const CtaSection = () => {
  return (
    <section id="cta" className={styles.ctaSection}>
      <div className={styles.ctaBg} aria-hidden="true">
        <div className={styles.bgNoise} />
        <div className={styles.bgGlow1} />
        <div className={styles.bgGlow2} />
        <div className={styles.bgGrid} />
      </div>

      <ScrollReveal>
        <div className={styles.ctaInner}>
          <div className={styles.ctaBox}>
            <div className={styles.ctaBadge}>
              <span className={styles.ctaBadgeDot} />
              <FormattedMessage id="cta.badge" defaultMessage="Pronto para começar?" />
            </div>

            <h2 className={styles.ctaTitle}>
              <FormattedMessage id="cta.title" />
            </h2>
            <p className={styles.ctaDescription}>
              <FormattedMessage id="cta.description" />
            </p>

            <ul className={styles.benefitList}>
              {benefits.map(b => (
                <li key={b.id} className={styles.benefitItem}>
                  <span className={styles.benefitIcon}><FaCheck size={10} /></span>
                  <FormattedMessage id={b.id} defaultMessage={b.def} />
                </li>
              ))}
            </ul>

            <div className={styles.ctaActions}>
              <CtaButton href="/register" variant="primary">
                <FormattedMessage id="cta.button" />
              </CtaButton>
            </div>
          </div>
        </div>
      </ScrollReveal>
    </section>
  );
};

export default injectIntl(CtaSection);
